import { html } from 'chipta-libs/main.js';
import { getCsrfToken } from 'chipta-libs/utils/http.js';

export function csrfHiddenInput() {
  return html`<input type="hidden" name="csrfmiddlewaretoken" value="${getCsrfToken()}">`;
}
